import { createAction, props } from '@ngrx/store';

export const OrderTypesRequest = createAction('[Order Types] Request order types');

export const OrderTypesSuccessRequest = createAction('[Order Types] Success request order types', props<{ payload: OLO.DTO.OrderTypeModel[] }>());

export const OrderTypesErrorRequest = createAction('[Order Types] Error request order types');
